import React, { createContext, useContext, type ReactNode } from "react";
import { PropertyStore } from "./PropertyStore";
import { FilterStore } from "./FilterStore";
import { ContactStore } from "./ContactStore";

interface Stores {
  propertyStore: PropertyStore;
  filterStore: FilterStore;
  contactStore: ContactStore;
}

const propertyStore = new PropertyStore();
const filterStore = new FilterStore();
const contactStore = new ContactStore();

const storesContext = createContext<Stores>({
  propertyStore,
  filterStore,
  contactStore,
});

export const useStores = (): Stores => useContext(storesContext);

interface StoreProviderProps {
  children: ReactNode;
}

export const StoreProvider: React.FC<StoreProviderProps> = ({ children }) => {
  return (
    <storesContext.Provider value={{ propertyStore, filterStore, contactStore }}>
      {children}
    </storesContext.Provider>
  );
};
